import { render, staticRenderFns } from "./PriyomSmenaClosed.vue?vue&type=template&id=6a2a389a&scoped=true&"
import script from "./PriyomSmenaClosed.vue?vue&type=script&lang=js&"
export * from "./PriyomSmenaClosed.vue?vue&type=script&lang=js&"
import style0 from "./PriyomSmenaClosed.vue?vue&type=style&index=0&id=6a2a389a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2a389a",
  null
  
)

export default component.exports